import { PUBLIC_INSPECTION_SHARE } from '../../constants/routeDestinations';
export const BASE_URL = '/api/v1/';
export const LOGIN_ENDPOINT = `${BASE_URL}login`;
export const LOGOUT_ENDPOINT = `${BASE_URL}logout`;
export const SSO_ATTACH_URL = `${BASE_URL}sso/attach-url`;
export const SESSION_USER_ENDPOINT = `${BASE_URL}session-user`;
export const INSPECTIONS_BY_CREATOR = `${BASE_URL}officers/\${officerId}/inspections`;
export const INSPECTIONS_BY_PROVIDER = `${BASE_URL}service-providers/\${serviceProviderId}/inspections`;
export const INSPECTIONS = `${BASE_URL}inspections`;
export const INSPECTION_WITH_ADDRESS = `${BASE_URL}inspectionWithAddress`;
export const ONE_INSPECTION = `${INSPECTIONS}/\${id}`;
export const ONE_INSPECTION_EXPORT = `${INSPECTIONS}/\${id}/export`;
export const INSPECTIONS_EXPORT = `${INSPECTIONS}/export/\${scope}/\${statusId}`;
export const ONE_INSPECTION_BY_SHARE_TOKEN = `${INSPECTIONS}/token/\${token}/share`;
export const ONE_INSPECTION_BY_EXPORT_TOKEN = `${INSPECTIONS}/token/\${token}/export`;
export const LOCATIONS = `${BASE_URL}locations/\${id}`;
export const INSPECTION_ELEMENT_CATEGORIES = `${INSPECTIONS}/\${id}/element-categories`;
export const ELEMENT_CATEGORIES = `${BASE_URL}element-categories`;
export const ACTION_TYPES = `${BASE_URL}action-types`;
export const STATUSES = `${BASE_URL}statuses`;
export const INSPECTION_SETTINGS_BY_INSPECTION = `${INSPECTIONS}/\${inspectionId}/settings`;
export const ONE_INSPECTION_SETTINGS = `${BASE_URL}inspection-settings/\${id}`;
export const HHSRS_SCORING_BY_INSPECTION = `${INSPECTIONS}/\${inspectionId}/scoring`;
export const HHSRS_VALIDATION_STATUS = `${INSPECTIONS}/\${inspectionId}/validate`;
export const HHSRS_NATIONAL_AVERAGES_FOR_HAZARD = `${INSPECTIONS}/\${inspectionId}/scoring/national-averages/\${hazardId}`;
export const HHSRS_CLEAR_RESCORE_WARNING = `${INSPECTIONS}/\${inspectionId}/clear-rescore-warning/\${hazardId}`;
export const DOCUMENT_BY_VARIANT = `${BASE_URL}documents/\${documentId}/\${variant}`;
export const DOCUMENT_BY_VARIANT_WITH_TOKEN = `${BASE_URL}documents/\${documentId}/\${variant}/token/\${token}`;
export const DOCUMENTS = `${BASE_URL}documents`;
export const ONE_DOCUMENT = `${BASE_URL}documents/\${id}`;
export const DOCUMENT_LABELS = `${BASE_URL}document-labels`;
export const DOCUMENTS_INCLUDE_IN_REPORT = `${BASE_URL}documents/\${defectId}/include-in-report`;
export const REMOTE_SUBMISSIONS_BY_TOKEN = `${BASE_URL}remote-submissions/\${token}`;
export const OFFICER_INVITES = `${BASE_URL}officer-invites`;
export const ONE_OFFICER_INVITE_BY_TOKEN = `${BASE_URL}officer-invites/token/\${token}`;
export const OFFICER_INVITES_BY_SERVICE_PROVIDER = `${BASE_URL}service-providers/\${id}/officer-invites`;
export const OFFICERS = `${BASE_URL}officers`;
export const OFFICER_ROLES = `${BASE_URL}officers/roles`;
export const UPDATE_OFFICER = `${BASE_URL}officers/\${id}`;
export const OFFICERS_BY_SERVICE_PROVIDER = `${BASE_URL}service-providers/\${id}/officers`;
export const CREATE_BY_INVITE = `${BASE_URL}users/invite`;
export const EMAIL_EXISTS = `${BASE_URL}sso/email-exists/\${email}`;
export const UPDATE_LICENCE_RECORD = `${BASE_URL}licence-records/\${licenceType}`;
export const SERVICE_PROVIDERS = `${BASE_URL}service-providers`;
export const ONE_SERVICE_PROVIDER = `${BASE_URL}service-providers/\${id}`;
export const PROPERTY_TYPES = `${BASE_URL}property-types`;
export const PROPERTY_DETACHMENTS = `${BASE_URL}property-detachments`;
export const PROPERTY_AGES = `${BASE_URL}property-ages`;
export const ADDRESSES_BY_POSTCODE = `${BASE_URL}address-finder/\${postcode}`;
export const ONE_ADDRESS = `${BASE_URL}addresses/\${id}`;
export const ADDRESSES = `${BASE_URL}addresses`;
export const PROPERTIES = `${BASE_URL}properties`;
export const ONE_PROPERTY = `${PROPERTIES}/\${id}`;
export const EPC_LOOKUP_BY_PROPERTY = `${PROPERTIES}/\${id}/epc-lookup`;
export const ONE_PROPERTY_EPC = `${BASE_URL}property-epcs/\${id}`;
export const PROPERTY_EPCS = `${BASE_URL}property-epcs`;
export const ONE_DEFECT = `${BASE_URL}defects/\${id}`;
export const DEFECTS = `${BASE_URL}defects`;
export const ONE_HAZARD = `${BASE_URL}hazards/\${id}`;
export const HAZARDS = `${BASE_URL}hazards`;
export const ONE_DEFECT_NOTE = `${BASE_URL}defect-notes/\${id}`;
export const DEFECT_NOTES = `${BASE_URL}defect-notes`;
export const TAGS = `${BASE_URL}tags`;
export const OWNER_TYPES = `${BASE_URL}owner-types`;
export const AGE_RANGES = `${BASE_URL}occupant-age-ranges`;
export const ONE_CONTACT = `${BASE_URL}contacts/\${id}`;
export const CONTACTS = `${BASE_URL}contacts`;
export const ONE_CONTACT_FULL = `${BASE_URL}contacts_full/\${id}`;
export const CONTACTS_FULL = `${BASE_URL}contacts_full`;
export const ONE_TENANT = `${BASE_URL}tenants/\${id}`;
export const TENANTS = `${BASE_URL}tenants`;
export const TENANCY_TYPES = `${BASE_URL}tenancy-types`;
export const OCCUPANTS = `${BASE_URL}occupants`;
export const ONE_OCCUPANT = `${BASE_URL}occupants/\${id}`;
export const HOUSEHOLDS = `${BASE_URL}households`;
const replaceTemplatePlaceholder = (placeholderName, replacementText, templateText) => {
    const replaceTarget = `\${${placeholderName}}`;
    return templateText.replace(replaceTarget, replacementText);
};
export const generateEndpoint = (endpointTemplate, params) => {
    let renderedTemplate = endpointTemplate;
    if (params) {
        for (const key in params) {
            if (Object.hasOwn(params, key)) {
                renderedTemplate = replaceTemplatePlaceholder(key, params[key], renderedTemplate);
            }
        }
    }
    return renderedTemplate;
};
export const getInspectionShareUrl = (inspectionSettings) => generateEndpoint(PUBLIC_INSPECTION_SHARE, {
    token: inspectionSettings.share_token,
});
